export const callFunctionAfterMs = async function (func, timeMs) {
  return new Promise(resolve => {
    setTimeout(() => {
      const result = func();
      return resolve(result);
    }, timeMs);
  });
};
